import { Dialog } from "construct-ui";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import SEAOGoodMovementModel from "../../models/retail-asset-management/seao-goods-movement.model";
import ViewBase from "../view-base.view";
import { addSEAOPosmStorageLocation, getSEAOCommonForPopup } from "../../models/retail-asset-management/seao-posm-master.model";

export default function WarehouseStorageSelectCreateComponent() {
  const BOOTSTRAP_INVALID_CLASS = 'is-invalid';
  ViewBase.call(this);
  const CREATE_MODE = {
    WAREHOUSE: 'Warehouse',
    STORARE_LOCATION: 'StorageLocation',
  };
  const dialogTitle = {
    Warehouse: {
      code: "LT00001294",
      content: "New Warehouse"
    },
    StorageLocation: {
      code: "LT00001295",
      content: "New Storage Location"
    }
  }

  let currentCreateMode = CREATE_MODE.WAREHOUSE;
  let movementDetail = structuredClone({
    warehouse: SEAOGoodMovementModel?.movementDetail?.warehouse,
    storageLocation: SEAOGoodMovementModel?.movementDetail?.storageLocation,
  });
  let isCreateDialogOpen = false

  const getCurrentCreateMode = (movementDetail) => {
    if (!movementDetail.warehouse.code) {
      return CREATE_MODE.WAREHOUSE;
    } else return CREATE_MODE.STORARE_LOCATION
  }
  const onSave = (e) => {
    e.preventDefault();
    let input = document.getElementById('input')
    if (!input?.value) {
      input?.classList.add(BOOTSTRAP_INVALID_CLASS)
      return;
    }
    addPosmStorageLocation(input, movementDetail?.warehouse?.code)

  }
  const handleInput = (e) => {
    let input = document.getElementById('input')
    if (input?.value) {
      input?.classList.remove(BOOTSTRAP_INVALID_CLASS)
    }
  }
  const addPosmStorageLocation = (input, wareHouseId) => {
    wareHouseId = currentCreateMode == CREATE_MODE.WAREHOUSE ? 0 : wareHouseId;
    this.showLoading();
    addSEAOPosmStorageLocation({ CateName: input?.value, Type: currentCreateMode, WarehouseId: wareHouseId })
      .then((data) => {
        if (data[0].transStatus == "SUCCESS") {
          this.showMessage('success', null, () => {
            isCreateDialogOpen = false;
          });
        } else {
          this.showErrorMessage(data[0].message, null, () => {
          })
        }
        if (currentCreateMode == CREATE_MODE.WAREHOUSE) {
          getAllWareHouse();
        } else {
          getAllStorageLocation(movementDetail?.warehouse?.code);
        }
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading()
      })

  }
  const getAllWareHouse = () => {
    this.showLoading();
    getSEAOCommonForPopup({ DataType: 'POSM_WAREHOUSE', DataCode: '', DataName: '', ParameterDataCode: '' }).then((data) => {
      SEAOGoodMovementModel.warehouse = data.data;
    }).catch((err) => {
      this.handleError(err);
    }).finally(() => {
      this.hideLoading();
    });
  }
  const getAllStorageLocation = (wareHouseId) => {
    this.showLoading();
    getSEAOCommonForPopup({ DataType: 'POSM_STORAGE', DataCode: "", DataName: '', ParameterDataCode: wareHouseId }).then((data) => {
      SEAOGoodMovementModel.storageLocation = data.data;
    }).catch((err) => {
      this.handleError(err);
    }).finally(() => {
      this.hideLoading()
    })
  }

  const getDialogTitle = () => {
    return this.getText(dialogTitle[currentCreateMode]?.code, dialogTitle[currentCreateMode]?.content)
  }

  return {
    oninit: () => {
      currentCreateMode = getCurrentCreateMode(SEAOGoodMovementModel.movementDetail);
      getAllWareHouse();
      if (currentCreateMode == CREATE_MODE.STORARE_LOCATION) {
        getAllStorageLocation(SEAOGoodMovementModel.movementDetail.warehouse.code);
      }
    },
    view: () => {
      const movementDetail = SEAOGoodMovementModel.movementDetail
      return [
        m('.row.row-cols-5.g-2.align-items-center',
          m('.col.position-relative',
            m('label.form-label', this.getText('LT00001269', CREATE_MODE.WAREHOUSE)),
            m('.input-group',
              m(SingleSelectComponent, {
                activeIndex: (SEAOGoodMovementModel.warehouse.findIndex((item) => { return item.code == movementDetail.warehouse.code }) + 1) || 0,
                popoverAttrs: { class: 'posm-filters' },
                allowEmpty: SEAOGoodMovementModel.warehouse.length != 0,
                items: SEAOGoodMovementModel.warehouse,
                selectedItem: movementDetail.warehouse,
                checkmark: true,
                filterable: true,
                onSelect: (s) => {
                  const oldCode = movementDetail.warehouse.code;
                  SEAOGoodMovementModel.setMovementDetail({ warehouse: s });
                  if (s.code && s.code != oldCode) {
                    getAllStorageLocation(s.code);
                  }
                  if (!s.code || s.code != oldCode) {
                    SEAOGoodMovementModel.setMovementDetail({ storageLocation: { code: null, name: null } });
                  }
                },
              }),
              !movementDetail.warehouse.code &&
              m('button.btn.btn-sm.btn-primary',
                {
                  onclick: () => {
                    isCreateDialogOpen = true;
                  },
                },
                [m('i.bi.bi-plus-lg.me-0')]
              )
            )
          ),
          m('.col.position-relative', movementDetail.warehouse.code && [
            m('label.form-label', this.getText('LT00001270', 'Storage Location')),
            m('.input-group',
              m(SingleSelectComponent, {
                activeIndex: (SEAOGoodMovementModel.storageLocation.findIndex((item) => { return item.code == movementDetail.storageLocation.code }) + 1) || 0,
                popoverAttrs: { class: 'posm-filters' },
                allowEmpty: SEAOGoodMovementModel.storageLocation.length != 0,
                items: SEAOGoodMovementModel.storageLocation,
                selectedItem: movementDetail.storageLocation,
                checkmark: true,
                filterable: true,
                onSelect: (s) => {
                  SEAOGoodMovementModel.setMovementDetail({ storageLocation: s });
                },
              })
            ),
          ]),
          m('.col.position-relative'),
          m('.col.position-relative'),

          m(Dialog, {
            isOpen: isCreateDialogOpen,
            closeOnOutsideClick: false,
            closeOnEscapeKey: false,
            title: getDialogTitle(),
            class: 'cui-dialog-xxl',
            onClose: () => {
              isCreateDialogOpen = false;
            },
            content: m('.card',
              m('.card-body',
                m('form.needs-validation[novalidate]', { id: 'form', onsubmit: onSave },
                  m('.row.g-2',
                    m('.col-md-12.position-relative',
                      m('label.form-label.mandatory[for="input"]',
                        `${getDialogTitle()}`
                      ),
                      m(`input#input.form-control.form-control-bg[required][type=text][placeholder=${getDialogTitle()}]`
                        , {
                          maxlength: 100,
                          oninput: handleInput
                        }
                      ),
                      m('.invalid-tooltip', this.getText('LT00000903', 'Please check required fields')),
                    ),
                  )
                )
              ),

            ),
            footer: m('row',
              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary',
                  {
                    type: 'submit',
                    form: 'form',
                  },
                  this.getText('LT00000022', 'Save')
                ),
                m('button.btn.btn-white',
                  {
                    onclick: () => {
                      isCreateDialogOpen = false;
                    },
                  },
                  this.getText('LT00000021', 'Close')
                )
              )
            ),
          }),
        ),
        this.getBaseViews(),
      ]
    }
  }
}